import { alpha } from '@mui/material/styles';
import { makeStyles } from '@mui/styles';

const colors = {
  background: {
    white: '#ffffff',
    black: '#000000',
    gray1: '#f5f5f5',
    gray2: '#e0e0e0',
    gray3: '#999999',
  },
  primary: {
    main: '#3C55E8',
  },
};

export const useStyles = makeStyles({
  wrapper: {
    height: '100%',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
  },
  container: {
    backgroundColor: colors.background.white,
    borderRadius: '14px',
    border: `1px solid ${colors.background.gray1}`,
    width: '1024px',
    height: '700px',
    display: 'flex',
    flexDirection: 'column',
  },
  header: {
    borderBottom: `1px solid ${colors.background.gray2}`,
    height: '61px',
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
    padding: '0px 24px',
    flexShrink: 0, // Prevent header from shrinking
  },
  title: {
    fontSize: '24px',
    color: colors.background.black,
    fontFamily: 'Montserrat, Arial, sans-serif',
  },
  content: {
    flex: '1',
    display: 'flex',
    minHeight: 0, // Allow content to shrink properly
    overflow: 'hidden', // Prevent content from expanding beyond bounds
  },
  gallery: {
    flex: '1',
    padding: '32px 0px',
    marginRight: '24px',
    minHeight: 0, // Allow gallery to shrink properly
    overflow: 'hidden', // Ensure gallery doesn't overflow
  },
  footer: {
    borderTop: `1px solid ${colors.background.gray2}`,
    height: '61px',
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'flex-end',
    padding: '0px 32px',
    flexShrink: 0, // Prevent footer from shrinking
  },
  button: {
    borderRadius: '4px',
    padding: '6px 12px',
    fontWeight: '600',
    '&:not(:last-child)': {
      marginRight: '32px',
    },
  },
  saveButton: {
    backgroundColor: colors.primary.main,
    color: colors.background.white,
    '&:hover': {
      backgroundColor: colors.primary.main,
    },
  },
  cancelButton: {
    backgroundColor: alpha(colors.primary.main, 0.05),
    color: colors.primary.main,
    '&:hover': {
      backgroundColor: alpha(colors.primary.main, 0.15),
    },
  },
  closeButton: {
    fill: colors.background.gray3,
  },
});
